import Page from "../Common/Page";
import React from "react";
import {
  Input,
  Table,
  Form,
  Button,
  Row,
  Col,
  Select,
  Space,
  Popconfirm,
  message,
} from "antd";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import moment from "moment";
import withRouterDom from "../Common/WithReactRouterDom";
import { rubricScoringPatternType } from "../Common/AppSettings";
import { NavigateFunction } from "react-router-dom";
import { AuthorityButton } from "../Components/AuthorityButton";
import { Messages } from "../Common/ValidateMessages";

const { Option } = Select;

interface Props {
  isPopup?: boolean;
  groupCreationRequiredFlag?: string;
  scoringType?: string;
  onSelect?: (value: any) => void;
  navigation?: NavigateFunction;
}
interface Rubric {
  rubricId: string;
  rubricName: string;
  studentCountFlag: string;
  scoringPatternType: string;
  updatedOn: Date;
  updatedByUserName: string;
}
interface RubricSearchRequestBean {
  rubricName: string | undefined;
  scoringPatternType: string | undefined;
}

export class RubricList extends React.Component<Props> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _pageSize = 5;

  state = {
    rubricName: undefined,
    scoringPatternType: undefined,
    rubricList: [],
  };

  constructor(props: any) {
    super(props);
    this._page = React.createRef<Page>();
    if (this.props.isPopup) {
      this._pageSize = 5;
    } else {
      this._pageSize = 10;
    }
  }

  columns = [
    {
      title: <div className="table-title">No</div>,
      key: "no",
      width: "5%",
      render: (value: any, item: Rubric, index: number) => (
        <span>{index + 1}</span>
      ),
    },
    {
      title: <div className="table-title">ルーブリック名</div>,
      dataIndex: "rubricName",
      key: "rubricName",
      width: "30%",
    },
    {
      title: <div className="table-title">採点対象人数区分</div>,
      dataIndex: "studentCountFlag",
      key: "studentCountFlag",
      width: "15%",
      render: (value: any, item: Rubric, index: number) => {
        if (item.studentCountFlag === "0") {
          return <span>1人</span>;
        } else {
          return <span>複数人</span>;
        }
      },
    },
    {
      title: <div className="table-title">採点パターン</div>,
      dataIndex: "scoringPatternType",
      key: "scoringPatternType",
      width: "20%",
      render: (value: any, item: Rubric, index: number) => (
        <span>
          ({item.scoringPatternType})
          {rubricScoringPatternType[item.scoringPatternType]}
        </span>
      ),
    },
    {
      title: <div className="table-title">最終更新日時</div>,
      dataIndex: "updatedOn",
      key: "updatedOn",
      width: "15%",
      render: (value: any, item: Rubric, index: number) =>
        moment(item.updatedOn).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: <div className="table-title">最終更新者</div>,
      dataIndex: "updatedByUserName",
      key: "updatedByUserName",
      width: "15%",
    },
    {
      title: "",
      key: "action",
      width: "15%",
      render: (value: any, item: Rubric, index: number) => (
        <Space size="middle" direction="horizontal">
          {this.props.isPopup && (
            <Button
              type="dashed"
              htmlType="button"
              onClick={() => {
                if (
                  this.props.groupCreationRequiredFlag &&
                  this.props.scoringType
                ) {
                  // ・試験科目一覧の各行について、選択されたルーブリックの採点対象人数区分(1:1人用 2:複数人用) と 試験科目登録画面[採点人数]の不一致はエラー
                  // 　→試験科目の採点人数(1人)に対して、選択されたルーブリックに"複数人用"が選択されました
                  // 　→試験科目の採点人数(複数人)に対して、選択されたルーブリックに"1人用"が選択されました
                  // ・試験科目一覧の各行について、試験科目登録画面.[採点種別]＝"答案"の場合、採点パターン1,4,6,7,9"以外"はエラー
                  // 　→試験科目＝答案の場合、選択できるルーブリックの採点パターンは(1),(4),(6),(7),(9)です
                  // 　※面接の場合は、採点パターン1～9全て利用OK！
                  if (
                    this.props.groupCreationRequiredFlag === "1" &&
                    item.studentCountFlag === "0"
                  ) {
                    message.error(Messages["ERR-063"]);
                    return;
                  }
                  if (
                    this.props.groupCreationRequiredFlag === "0" &&
                    item.studentCountFlag === "1"
                  ) {
                    message.error(Messages["ERR-064"]);
                    return;
                  }
                  if (
                    this.props.scoringType === "1" &&
                    item.studentCountFlag === "1"
                  ) {
                    message.error(Messages["ERR-065"]);
                    return;
                  }
                }
                this.props.onSelect?.(item);
              }}
            >
              選択
            </Button>
          )}
          {!this.props.isPopup && (
            <Button
              type="primary"
              htmlType="button"
              onClick={() => {
                const { navigation } = this.props;
                navigation!("/RubricRegister/" + item.rubricId);
              }}
            >
              編集
            </Button>
          )}
          {!this.props.isPopup && (
            <Popconfirm
              title={Messages["CON-001"]}
              okText="はい"
              cancelText="いいえ"
              onConfirm={() => {
                this.onDelete(item.rubricId);
              }}
            >
              <AuthorityButton
                functioncode="FU-62"
                authority="2"
                type="primary"
              >
                削除
              </AuthorityButton>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  searchRubric = async () => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      const postData: RubricSearchRequestBean = {
        rubricName: this.state.rubricName,
        scoringPatternType: this.state.scoringPatternType,
      };
      const result = await http<Rubric[], RubricSearchRequestBean>({
        path: "/Rubric/search",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        this.setState({
          rubricList: result.body,
        });
        this._page.current?.setState({ isPageLoading: false });
      } else {
        this._page.current?.setState({ isPageLoading: false });
      }
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };
  onFinish = async (values: any) => {
    this.setState({
      rubricName: values.rubricName ? values.rubricName : undefined,
      scoringPatternType: values.scoringPatternType
        ? values.scoringPatternType
        : undefined,
    });
    this.searchRubric();
  };

  onDelete = async (rubricId: string) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      const postData: any = { rubricId: rubricId };
      const result = await http<any, any>({
        path: "/Rubric/delete",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      this._page.current?.setState({ isPageLoading: false });
      if (result.ok) {
        if (result.body?.result === "1") {
          this.searchRubric();
        } else {
          message.error(Messages["ERR-045"]);
        }
      }
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  render(): React.ReactNode {
    return (
      <Page
        title={this.props.isPopup ? undefined : "ルーブリック一覧"}
        ref={this._page}
      >
        <div className="data_content">
          <Form
            colon={false}
            layout="horizontal"
            labelCol={{ span: 6 }}
            labelAlign="left"
            className={this.props.isPopup ? "" : "search_form"}
            name="searchForm"
            onFinish={this.onFinish}
          >
            <Row>
              <Col span={10}>
                <Form.Item label="ルーブリック名" name="rubricName">
                  <Input style={{ width: "60%" }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="採点パターン" name="scoringPatternType">
                  <Select style={{ width: "250px" }} allowClear={true}>
                    <Option value="1">(1)ルーブリック基本</Option>
                    <Option value="2">(2)カテゴリ別</Option>
                    <Option value="3">(3)ディスカッション</Option>
                    <Option value="4">(4)合計得点のみ</Option>
                    <Option value="5">(5)グループ面接</Option>
                    <Option value="6">(6)評価コメントのみ</Option>
                    <Option value="7">(7)評価コメントのみ</Option>
                    <Option value="8">(8)グループ面接(評価コメントつき)</Option>
                    <Option value="9">(9)評価点選択式</Option>
                  </Select>
                </Form.Item>
              </Col>
              {/* {this.props.isPopup === undefined && (
                <Col span={4}>
                  <Form.Item>
                    <AuthorityButton
                      functioncode="FU-62"
                      authority="2"
                      type="primary"
                      onClick={() => {
                        const { navigation } = this.props;
                        navigation!("/RubricRegister");
                      }}
                    >
                      新規登録
                    </AuthorityButton>
                  </Form.Item>
                </Col>
              )} */}
              {/* </Row>
            <Row> */}
              <Col span={4}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    検索
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Table
            rowKey={(record: any) => record.rubricId}
            bordered
            size={"small"}
            columns={this.columns}
            dataSource={this.state.rubricList}
            // scroll={{ y: 1200 }}
            pagination={{
              size: "small",
              pageSize: this._pageSize,
              position: ["topLeft"],
              showTotal: (total) => {
                return (
                  <ul className="resultCount">
                    <li className="grey">
                      対象<span>{total}</span>
                    </li>
                  </ul>
                );
              },
              onChange: (current) => this.setState({ page: current }),
            }}
          />
        </div>
      </Page>
    );
  }
}

export default withRouterDom(RubricList);
